import React from 'react'

import { BsPeopleFill } from "react-icons/bs";
import { FaChild } from "react-icons/fa";
import { ImManWoman } from "react-icons/im"
import { MdFamilyRestroom } from "react-icons/md"

export const links = [
    {
      id: 1,
      text: 'home',
      url: '/',
    },
    {
      id: 2,
      text: 'sobre',
      url: '/sobre',
    },
    {
      id: 3,
      text: 'psicoterapia',
      url: '/psicoterapia',
    },
    {
      id: 4,
      text: 'publicações',
      url: '/publicacoes',
    },
    {
      id: 5,
      text: 'contactos',
      url: '/contactos',
    },
  ]

  export const featured_services = [
    {
      id: 1,
      icon: <BsPeopleFill className="featured-icon" />,
      title: 'Psicoterapia de Adultos',
      bgColor: '#A8C8ED',
      text:'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptates, ea. Perferendis corrupti reiciendis nesciunt rerum velit autem unde numquam nisi',
    },
    {
      id: 2,
      icon: <FaChild className="featured-icon" />,
      title: 'Psicoterapia de Crianças e Adolescentes',
      bgColor: '#D1D6DC',
      text:'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptates, ea. Perferendis corrupti reiciendis nesciunt rerum velit autem unde numquam nisi',
    },
    {
      id: 3,
      icon: <ImManWoman className="featured-icon" />,
      title: 'Terapia de Casal',
      bgColor: '#C1D7EF',
      text:'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptates, ea. Perferendis corrupti reiciendis nesciunt rerum velit autem unde numquam nisi',
    },
    {
      id: 4,
      icon: <MdFamilyRestroom  className="featured-icon"/>,
      title: 'Terapia Familiar',
      bgColor: '#8FC6E2',
      text:'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptates, ea. Perferendis corrupti reiciendis nesciunt rerum velit autem unde numquam nisi',
    },
  ]

  export const publications_url = 'https://www.davidpadua.com/json/publications-jessica-tacoen.json'